import { LegalPageLayout } from "@/components/legal/LegalPageLayout";
import { LegalSection } from "@/components/legal/LegalSection";

const tableOfContents = [
  { id: "gioi-thieu", title: "Giới thiệu", level: 1 },
  { id: "cookies-la-gi", title: "Cookies là gì", level: 1 },
  { id: "loai-cookies", title: "Các loại Cookies chúng tôi sử dụng", level: 1 },
  { id: "muc-dich-su-dung", title: "Cách chúng tôi sử dụng Cookies", level: 1 },
  { id: "cookies-ben-thu-ba", title: "Cookies bên thứ ba", level: 1 },
  { id: "quan-ly-cookies", title: "Quản lý tùy chọn Cookies", level: 1 },
  { id: "danh-sach-cookies", title: "Thông tin chi tiết về Cookies", level: 1 },
  { id: "cap-nhat", title: "Cập nhật chính sách này", level: 1 },
  { id: "lien-he", title: "Liên hệ với chúng tôi", level: 1 },
];

export default function CookiePolicyVietnamese() {
  return (
    <LegalPageLayout
      title="Chính sách Cookie"
      lastUpdated="6 tháng 1, 2025"
      language="vi"
      alternateUrl="/pages/cookies"
      tableOfContents={tableOfContents}
    >
      {/* Vietnamese cookie sections extracted to reduce file size */}
      <LegalSection id="gioi-thieu" title="Giới thiệu">
        <p>
          Chính sách Cookie này giải thích cách Cloudjet Solutions Pte. Ltd. sử
          dụng cookies và các công nghệ theo dõi tương tự.
        </p>
        <p>
          Chính sách này nên được đọc cùng với{" "}
          <a href="/pages/vi/privacy" className="text-blue-600 hover:underline">
            Chính sách Bảo mật
          </a>{" "}
          của chúng tôi.
        </p>
      </LegalSection>

      <LegalSection id="cookies-la-gi" title="Cookies là gì">
        <p>
          Cookies là các tệp văn bản nhỏ được lưu trữ trên thiết bị của bạn khi
          bạn truy cập trang web.
        </p>
        <h3>Công nghệ tương tự</h3>
        <p>
          Chúng tôi cũng sử dụng Web Beacons, Local Storage, Session Storage và
          Pixels.
        </p>
      </LegalSection>

      <LegalSection
        id="loai-cookies"
        title="Các loại Cookies chúng tôi sử dụng"
      >
        <h3>Cookies cần thiết</h3>
        <p>Cookies cần thiết cho hoạt động cơ bản của website.</p>

        <h3>Cookies phân tích</h3>
        <p>Giúp chúng tôi hiểu cách người dùng tương tác với website.</p>

        <h3>Cookies chức năng</h3>
        <p>Cho phép cá nhân hóa và nâng cao trải nghiệm.</p>

        <h3>Cookies tiếp thị</h3>
        <p>Được sử dụng để cung cấp quảng cáo phù hợp.</p>
      </LegalSection>

      <LegalSection
        id="muc-dich-su-dung"
        title="Cách chúng tôi sử dụng Cookies"
      >
        <h3>Xác thực và bảo mật</h3>
        <p>
          Chúng tôi sử dụng cookies để giữ bạn đăng nhập và bảo vệ tài khoản.
        </p>

        <h3>Nâng cao trải nghiệm</h3>
        <p>Cookies giúp ghi nhớ tùy chọn và cung cấp nội dung cá nhân hóa.</p>

        <h3>Phân tích và cải thiện</h3>
        <p>Chúng tôi phân tích dữ liệu để cải thiện website.</p>

        <h3>Tiếp thị</h3>
        <p>
          Với sự đồng ý, chúng tôi sử dụng cookies để cung cấp quảng cáo phù
          hợp.
        </p>
      </LegalSection>

      <LegalSection id="cookies-ben-thu-ba" title="Cookies bên thứ ba">
        <p>
          Chúng tôi làm việc với nhiều nhà cung cấp dịch vụ bên thứ ba có thể
          đặt cookies của riêng họ khi bạn sử dụng dịch vụ của chúng tôi. Bao
          gồm:
        </p>

        <h3>Nhà cung cấp phân tích</h3>
        <ul>
          <li>
            <strong>Google Analytics:</strong> Phân tích lưu lượng truy cập
            trang web và hành vi người dùng
          </li>
          <li>
            <strong>Facebook Analytics:</strong> Theo dõi tương tác mạng xã hội
          </li>
          <li>
            <strong>Mixpanel:</strong> Phân tích sản phẩm và theo dõi hành trình
            người dùng
          </li>
        </ul>

        <h3>Đối tác quảng cáo</h3>
        <ul>
          <li>
            <strong>Google Ads:</strong> Quảng cáo có mục tiêu và tiếp thị lại
          </li>
          <li>
            <strong>Facebook Ads:</strong> Quảng cáo mạng xã hội
          </li>
          <li>
            <strong>Twitter Ads:</strong> Tiếp thị mạng xã hội
          </li>
        </ul>

        <h3>Nền tảng mạng xã hội</h3>
        <ul>
          <li>
            <strong>Facebook:</strong> Đăng nhập xã hội và tính năng chia sẻ
          </li>
          <li>
            <strong>Google:</strong> Dịch vụ xác thực và tích hợp
          </li>
          <li>
            <strong>Twitter:</strong> Chia sẻ xã hội và nhúng
          </li>
        </ul>

        <h3>Hỗ trợ và truyền thông</h3>
        <ul>
          <li>
            <strong>Intercom:</strong> Chat hỗ trợ khách hàng
          </li>
          <li>
            <strong>Zendesk:</strong> Bàn trợ giúp và tạo phiếu
          </li>
          <li>
            <strong>Mailchimp:</strong> Tiếp thị và truyền thông qua email
          </li>
        </ul>

        <p>
          Vui lòng lưu ý rằng chúng tôi không kiểm soát những cookies bên thứ ba
          này. Chúng tôi khuyến nghị xem xét chính sách bảo mật của các nhà cung
          cấp này để biết thêm thông tin về hoạt động cookie của họ.
        </p>
      </LegalSection>

      <LegalSection
        id="quan-ly-cookies"
        title="Quản lý tùy chọn Cookies của bạn"
      >
        <h3>Cài đặt trình duyệt</h3>
        <p>
          Hầu hết các trình duyệt web cho phép bạn kiểm soát cookies thông qua
          cài đặt của chúng. Bạn thường có thể:
        </p>
        <ul>
          <li>Xem cookies được lưu trữ trên thiết bị của bạn</li>
          <li>Xóa cookies hiện có</li>
          <li>Chặn cookies trong tương lai</li>
          <li>Đặt tùy chọn cho các trang web cụ thể</li>
        </ul>

        <h3>Hướng dẫn cụ thể cho từng trình duyệt</h3>
        <div className="bg-gray-50 p-4 rounded-lg">
          <h4 className="font-semibold mb-2">
            Cài đặt Cookie trình duyệt phổ biến:
          </h4>
          <ul className="space-y-1">
            <li>
              <strong>Chrome:</strong> Cài đặt → Quyền riêng tư và Bảo mật →
              Cookies và dữ liệu trang web khác
            </li>
            <li>
              <strong>Firefox:</strong> Cài đặt → Quyền riêng tư & Bảo mật →
              Cookies và Dữ liệu trang web
            </li>
            <li>
              <strong>Safari:</strong> Tùy chọn → Quyền riêng tư → Quản lý dữ
              liệu trang web
            </li>
            <li>
              <strong>Edge:</strong> Cài đặt → Quyền trang web → Cookies và dữ
              liệu trang web
            </li>
          </ul>
        </div>

        <h3>Quản lý đồng ý Cookie</h3>
        <p>
          Khi bạn lần đầu truy cập trang web của chúng tôi, chúng tôi sẽ hiển
          thị banner đồng ý cookie nơi bạn có thể chọn loại cookies nào chấp
          nhận. Bạn có thể thay đổi những tùy chọn này bất cứ lúc nào bằng cách:
        </p>
        <ul>
          <li>
            Nhấp vào liên kết "Cài đặt Cookie" trong chân trang website của
            chúng tôi
          </li>
          <li>Truy cập cài đặt quyền riêng tư tài khoản của bạn</li>
          <li>Sử dụng trung tâm tùy chọn cookie</li>
        </ul>

        <h3>Tùy chọn từ chối</h3>
        <p>Đối với các loại theo dõi cụ thể, bạn có thể từ chối thông qua:</p>
        <ul>
          <li>
            <strong>Google Analytics:</strong>{" "}
            <a
              href="https://tools.google.com/dlpage/gaoptout"
              className="text-blue-600 hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Add-on trình duyệt từ chối Google Analytics
            </a>
          </li>
          <li>
            <strong>Quảng cáo:</strong>{" "}
            <a
              href="http://www.aboutads.info/choices/"
              className="text-blue-600 hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Từ chối Digital Advertising Alliance
            </a>
          </li>
          <li>
            <strong>Quảng cáo mạng:</strong>{" "}
            <a
              href="http://www.networkadvertising.org/choices/"
              className="text-blue-600 hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Từ chối Network Advertising Initiative
            </a>
          </li>
        </ul>

        <h3>Tác động của việc tắt Cookies</h3>
        <p>
          Vui lòng lưu ý rằng việc tắt một số cookies có thể ảnh hưởng đến chức
          năng của trang web của chúng tôi. Cookies cần thiết không thể bị tắt
          vì chúng cần thiết cho hoạt động cơ bản của trang web.
        </p>
      </LegalSection>

      <LegalSection
        id="danh-sach-cookies"
        title="Thông tin chi tiết về Cookies"
      >
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300">
            <thead className="bg-gray-50">
              <tr>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Tên Cookie
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Mục đích
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Loại
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Thời hạn
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 px-4 py-2">
                  locuno_session
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  Xác thực người dùng và quản lý phiên
                </td>
                <td className="border border-gray-300 px-4 py-2">Cần thiết</td>
                <td className="border border-gray-300 px-4 py-2">Phiên</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border border-gray-300 px-4 py-2">csrf_token</td>
                <td className="border border-gray-300 px-4 py-2">
                  Bảo vệ chống cross-site request forgery
                </td>
                <td className="border border-gray-300 px-4 py-2">Cần thiết</td>
                <td className="border border-gray-300 px-4 py-2">Phiên</td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">
                  user_preferences
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  Lưu trữ ngôn ngữ và tùy chọn hiển thị người dùng
                </td>
                <td className="border border-gray-300 px-4 py-2">Chức năng</td>
                <td className="border border-gray-300 px-4 py-2">1 năm</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border border-gray-300 px-4 py-2">_ga</td>
                <td className="border border-gray-300 px-4 py-2">
                  Google Analytics - phân biệt người dùng
                </td>
                <td className="border border-gray-300 px-4 py-2">Phân tích</td>
                <td className="border border-gray-300 px-4 py-2">2 năm</td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">_fbp</td>
                <td className="border border-gray-300 px-4 py-2">
                  Facebook Pixel - theo dõi chuyển đổi
                </td>
                <td className="border border-gray-300 px-4 py-2">Tiếp thị</td>
                <td className="border border-gray-300 px-4 py-2">3 tháng</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mt-4 text-sm text-gray-600">
          Bảng này hiển thị các cookies chính mà chúng tôi sử dụng. Có thể có
          các cookies bổ sung được đặt bởi các dịch vụ bên thứ ba được tích hợp
          vào nền tảng của chúng tôi.
        </p>
      </LegalSection>

      <LegalSection id="cap-nhat" title="Cập nhật chính sách này">
        <p>
          Chúng tôi có thể cập nhật Chính sách Cookie này theo thời gian để phản
          ánh những thay đổi trong thông lệ, công nghệ hoặc yêu cầu pháp lý của
          chúng tôi. Khi chúng tôi thực hiện những thay đổi đáng kể, chúng tôi
          sẽ thông báo cho bạn thông qua:
        </p>
        <ul>
          <li>Ngày "Cập nhật lần cuối" được cập nhật ở đầu chính sách này</li>
          <li>Banner thông báo trên trang web của chúng tôi</li>
          <li>
            Thông báo qua email cho người dùng đã đăng ký (đối với những thay
            đổi quan trọng)
          </li>
          <li>Thông báo trong ứng dụng</li>
        </ul>
        <p>
          Chúng tôi khuyến khích bạn xem xét Chính sách Cookie này định kỳ để
          được thông tin về cách chúng tôi sử dụng cookies.
        </p>
      </LegalSection>

      <LegalSection id="lien-he" title="Liên hệ với chúng tôi">
        <p>
          Nếu bạn có bất kỳ câu hỏi nào về việc sử dụng cookies của chúng tôi
          hoặc Chính sách Cookie này, vui lòng liên hệ với chúng tôi:
        </p>
        <div className="bg-gray-50 p-4 rounded-lg mt-4">
          <p>
            <strong>Email:</strong> privacy@locuno.com
          </p>
          <p>
            <strong>Tiêu đề:</strong> Câu hỏi về Chính sách Cookie
          </p>
          <p>
            <strong>Địa chỉ:</strong> Cloudjet Solutions Pte. Ltd.
            <br />
            71 Ayer Rajah Crescent
            <br />
            #02-10/11
            <br />
            Singapore 139951
          </p>
          <p>
            <strong>Cán bộ Bảo vệ Dữ liệu:</strong> dpo@locuno.com
          </p>
        </div>
        <p className="mt-4">
          Đối với các vấn đề kỹ thuật liên quan đến cài đặt cookie hoặc chức
          năng trang web, vui lòng liên hệ đội ngũ hỗ trợ của chúng tôi tại{" "}
          <a
            href="mailto:support@locuno.com"
            className="text-blue-600 hover:underline"
          >
            support@locuno.com
          </a>
          .
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
